import { z } from "zod";

export const ContentServerSchema = z.object({
  title: z.string().min(1),
});

export type ContentServerQueryParams = z.infer<typeof ContentServerSchema>;

export interface ContentServerItem {
  id: string;
  title: string;
  markdown: string;
  createdOnMillis: number;
  updatedOnMillis: number;
}

export interface ContentServerResponse {
  content: ContentServerItem;
}
